<template>
  <VanDialog
    :value="show"
    :show-confirm-button="false"
    :show-cancel-button="false"
    close-on-click-overlay
    overlayClass="refund-rule-overlay"
    class-name="refund-rule-dialog"
    @click-overlay="onClose"
    @close="onClose"
  >
    <div class="refund-rule">
      <div class="bg"></div>
      <div class="title">{{ agreementName }}</div>
      <div v-if="isRender" v-html="content" class="content"></div>
      <div class="bottom">
        <div class="btn" @click="onClose">我知道了</div>
      </div>
    </div>
  </VanDialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RefundRuleModal",
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      agreementName: "",
      content: "",
      isRender: false
    };
  },
  computed: {
    ...mapGetters({
      areaId: "home/areaId",
    }),
  },
  watch: {
    areaId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.requestRefundRule();
        }
      }
    },
    show(val) {
      if (val) {
        setTimeout(() => {
          this.isRender = true;
        }, 100);
      }
    }
  },
  methods: {
    requestRefundRule() {
      this.$OrderService.getRefundRule(this.areaId).then((agreement) => {
        const { agreementName, content } = agreement || {};
        this.agreementName = agreementName;
        this.content = content;
      });
    },
    onClose() {
      this.$emit('close')
      this.$emit("change", false);
    },
  },
};
</script>

<style lang="scss">
.refund-rule-overlay {
  background-color: rgba(0, 0, 0, 0.5)!important;
}
</style>
<style scoped lang="scss">
.refund-rule {
  position: relative;
  padding: 0 10px 0 20px;
  .bg {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 120px;
    background: linear-gradient(180deg, #bddeff 0%, #ffffff 100%),
      linear-gradient(193deg, #d9fff3 0%, rgba(255, 255, 255, 0) 100%);
  }

  .title {
    position: relative;
    height: 72px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #000000;
    line-height: 24px;
    text-align: center;
    font-style: normal;
  }

  .content {
    width: 100%;
    position: relative;
    max-height: 300px;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-bottom: 20px;
    font-family: PingFangSC, PingFang SC;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    text-align: justify;
    font-style: normal;
    white-space: wrap;
    padding-right: 10px;
  }
  .bottom {
    height: 88px;
    background: #ffffff;
    box-shadow: inset 0px 1px 0px 0px #eeeeee;
    border-radius: 0px 0px 20px 20px;
    display: flex;
    align-items: center;
  }
  .btn {
    width: 100%;
    height: 48px;
    background: #006efa;
    border-radius: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
    text-align: center;
    font-style: normal;
  }
}

.refund-rule-dialog {
  width: calc(100% - 20px);
  top: unset;
  bottom: calc(10px + constant(safe-area-inset-bottom));
  bottom: calc(10px + env(safe-area-inset-bottom));
  border-radius: 28px;
  padding: 0;
  transform: translate3d(-50%, 0, 0);
  ::v-deep .van-dialog__header {
    padding: 0;
    width: 100% !important;
    height: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    text-align: center;
    font-style: normal;
    border-bottom: 1px solid #eeeeee;
  }
  ::v-deep .van-dialog__footer {
    border: none;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #006efa;
    line-height: 22px;
    text-align: center;
    font-style: normal;
  }
}
</style>
